<nav [attr.aria-label]="menuName + ' options'" role="navigation" class="bl-position--relative bl-height--100">
    <ul id="admin-menu-header-container" class="bl-height--100" role="menubar">
      <li class="bl-height--100">
        <button
          aria-haspopup="true"
          [attr.aria-expanded]="menuExpanded"
          aria-controls="header-menu"
          class="admin-header-menu-toggle bl-height--100"
          [id]="toggleId"
          (click)="toggleMenu()"
          [class.admin-menu-selected]="menuExpanded"
        >
        <span [class]="toggleClass">{{toggleText}}</span>          
        </button>
        <ul
          id="header-menu"
          class="admin-header-menu bl-bg-color--black bl-font-color--white"
          role="menu"
          [attr.aria-label]="menuName + ' menu'"
          [hidden]="!menuExpanded"
        >
        <ng-content class="container-class"></ng-content>

        </ul>
      </li>
    </ul>
  </nav>